class ReportsFilter {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll( '.reports-section__filter-select' ).forEach( select => {
			select.addEventListener( 'change', () => select.closest( 'form' ).submit() );
		} );
	}
}

export default new ReportsFilter();
